import React, { useState, useEffect, useImperativeHandle, forwardRef } from 'react'
import styled from 'styled-components'

import { ActionBar } from './action-bar'
import { DataTable } from './data-table'
import { CreateBilling } from './create-billing'
import { allStatus } from './constants'
import { getProjectRevenue, getProjectAvailable, getInterpretBillingType } from '../../../../function/billing'

export const BillingTab = forwardRef((props, ref) => {
  const {
    // rSelected,
    projectByID = {},
    // getProjectInformationByID,
    editProjectInformation,
  } = props
  const { revenue_allocation = [] } = projectByID
  const { billings: billingData = [] } = projectByID
  const root = document.getElementById('root')
  const [billings, setBillings] = useState(billingData)
  const [editingBillings, setEditingBillings] = useState(billingData)
  const [isEditList, setIsEditList] = useState(false)
  const [isCreate, setIsCreate] = useState(false)

  const projectRevenue = getProjectRevenue(projectByID)
  const projectAvailable = getProjectAvailable(editingBillings, projectRevenue)
  const interpretBillingType = getInterpretBillingType(revenue_allocation)
  const canEdit = projectByID.$can_edit

  useEffect(() => {
    if (isEditList) {
      root.scrollTop = root.scrollHeight - root.clientHeight
    }
  }, [billings.length])

  useEffect(() => {
    setBillings(billingData)
    setEditingBillings(billingData)
  }, [projectByID])

  useImperativeHandle(ref, () => ({
    getIsEdit() {
      return isEditList
    },
    resetIsEdit() {
      setIsEditList(false)
    },
  }))

  const handleClickEditList = () => setIsEditList(true)

  const handleDiscardList = () => {
    const { billings = [] } = projectByID
    setBillings([...billings])
    setEditingBillings([...billings])
    setIsEditList(false)
  }

  const editBilling = () => {
    setBillings([...editingBillings])
  }

  const deleteBilling = billing_no => {
    const _billings = [...billings]
    const index = _billings.findIndex(b => b.billing_no === billing_no)
    _billings.splice(index, 1)
    let arr = _billings.slice(index)
    arr = arr.map(a => { return { ...a, billing_no: (+a.billing_no - 1).toString() } })
    _billings.splice(index, _billings.length - index, ...arr)
    setEditingBillings(_billings)
    setBillings(_billings)
  }

  const handleSave = () => {
    const payload = { ...projectByID }
    delete payload.project_type
    delete payload.created
    delete payload.project_approve_status
    delete payload.created_by
    delete payload.project_number
    delete payload.__v
    delete payload.project_status
    delete payload._id
    delete payload.updated_by
    payload.billings = billings
    editProjectInformation(payload)
    setIsEditList(false)
  }

  const handleClickCreate = () => {
    const billing_no = editingBillings.length > 0 ? (+editingBillings[editingBillings.length - 1].billing_no + 1).toString() : '1'
    setEditingBillings([
      ...editingBillings, {
        billing_types: [],
        name: '',
        invoice_date: null,
        status: allStatus.PLANNING,
        vat: '7',
        billing_no,
        remark: '',
      },
    ])
    setIsCreate(true)
  }

  const createDetail = () => {
    setBillings([...editingBillings])
    setIsCreate(false)
  }

  const updateEditingBillings = state => {
    setEditingBillings(state)
  }

  return (
    <Root>
      <ActionBar
        canEdit={ canEdit }
        isEditList={ isEditList }
        handleClickEditList={ handleClickEditList }
        handleDiscardList={ handleDiscardList }
        handleSave={ handleSave }
        billings={ billings }
        projectRevenue={ projectRevenue }
        projectAvailable={ projectAvailable }
      />
      <DataTable
        isEditList={ isEditList }
        handleClickCreate={ handleClickCreate }
        editBilling={ editBilling }
        deleteBilling={ deleteBilling }
        updateEditingBillings={ updateEditingBillings }
        billings={ billings }
        editingBillings={ editingBillings }
        revenueAllocation={ revenue_allocation }
        interpretBillingType={ interpretBillingType }
        projectRevenue={ projectRevenue }
        projectAvailable={ projectAvailable }
      />
      <CreateBilling
        isCreate={ isCreate }
        index={ editingBillings.length }
        data={ editingBillings[editingBillings.length - 1] || {} }
        editingBillings={ editingBillings }
        handleClose={ () => setIsCreate(false) }
        createDetail={ createDetail }
        updateEditingBillings={ updateEditingBillings }
        revenueAllocation={ revenue_allocation }
        billings={ billings }
        interpretBillingType={ interpretBillingType }
        projectRevenue={ projectRevenue }
        projectAvailable={ projectAvailable }
      />
    </Root>
  )
})

const Root = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`



// WEBPACK FOOTER //
// ./src/components/project-information/tab-content/tab-billing/index.js